<template>
    <div>
        <v-card>
                <v-toolbar flat dense class="info" dark>
                    <v-toolbar-title class="subheading">Acknowledgement</v-toolbar-title>
                </v-toolbar>
            <v-card-text class="text-xs-left">
                <v-checkbox
                    v-model="agreed"
                    :label="acknowledgementText"
                    ></v-checkbox>

                        <v-btn color="primary" :disabled="!agreed" @click="onAcknowledgeClick">Acknowledge</v-btn>

                        <div class="mt-3 disclaimer">
                            You are required to be familiar with the content of this policy and comply with it at all times. This policy does not form part of your employment agreement with your employer. Your employer may change, remove or replace this policy at any time. To the extent that this policy imposes obligations on your employer and/or purports to provide any right or benefit to you, those obligations are not contractual and do not give rise to any contractual rights.
                        </div>
            </v-card-text>
        </v-card>
        <v-dialog v-model="confirmDialog" persistent max-width="500px">
            <v-card>
                <v-form>
                    <v-toolbar flat dense cad>
                        <v-toolbar-title class="subheading">Confirm Acknowledgement</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-divider></v-divider>
                    <v-card-text class="acknowledge-message">
                        Are you sure you want to acknowledge the contents of this policy?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!agreed || isAgreeing" flat @click="onCancelClick">Cancel</v-btn>
                        <v-btn :disabled="!agreed || isAgreeing" :loading="isAgreeing" color="primary" flat @click="onAgree">Confirm <span slot="loader">Please Wait...</span></v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        isAgreeing: {
            type: Boolean,
            required: true
        },
        acknowledgementTextOption: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            agreed: false,
            confirmDialog: false
        }
    },
    computed: {
        acknowledgementText() {
            switch (this.acknowledgementTextOption) {
                case 0:
                    return "I acknowledge, agree and understand all aspects of this policy.";
                case 1:
                     return "I acknowledge, agree and understand all aspects of this policy. I am required to comply with this policy and there may be disciplinary consequences if I fail to comply.";
                default: 
                    return "I acknowledge, agree and understand all aspects of this policy.";
            }
        }
    },
    methods: {
        onAgree() {
            this.$emit('onAgree', {
                acknowledgementTextOption: this.acknowledgementTextOption,
                acknowledgementText: this.acknowledgementText
            });
        },
        onAcknowledgeClick() {
            this.confirmDialog = true;
        },
        onCancelClick() {
            this.confirmDialog = false;
        }

    }
}
</script>

<style scoped>
    .disclaimer {
        color: rgba(0, 0, 0, 0.54);
		font-size: 12px !important;
    }
    .acknowledge-message {
        margin-top: 20px;
        margin-bottom: 20px;
    }
</style>